// Renders the currently-pending modal surface inside the host Modal primitive.
// The Modal body is a SurfaceHost iframe; closing resolves the plugin's
// showModal promise. Mounted once by appPlugins.

import { type ReactElement } from 'react';
import { Modal } from '../components/Modal';
import { SurfaceHost } from './surfaces/SurfaceHost';
import { desktopSurfaceSrc } from './surfaces/surfaceSrc';
import { useSurfaceModalStore } from './surfaceModalStore';
import type { PluginSystem } from './setup';

export interface PluginSurfaceModalProps {
  system: PluginSystem;
}

export function PluginSurfaceModal({ system }: PluginSurfaceModalProps): ReactElement | null {
  const pending = useSurfaceModalStore((s) => s.pending);
  const close = useSurfaceModalStore((s) => s.close);
  if (!pending) return null;

  const surface = system.host
    .listSurfaces()
    .find((s) => s.pluginId === pending.pluginId && s.id === pending.surfaceId);
  if (!surface) return null;

  return (
    <Modal open onClose={close} title={surface.id} className="mp-surface-modal">
      <SurfaceHost
        system={system}
        pluginId={pending.pluginId}
        surfaceId={pending.surfaceId}
        src={desktopSurfaceSrc(pending.pluginId, surface.path)}
        title={surface.id}
      />
    </Modal>
  );
}
